import React from 'react'

import {
  useCubeReportAccessFiltersContext,
  useCubeReportPageFiltersContext,
} from 'cube'

import { Card, Header, Text } from '@driftt/dds'
import { CubeQueryStringAdapter } from '@driftt/dds.reports'

import { useTrackDrillDownClickEvent } from 'components/conversation/hooks/useTrackDrilldownClickEvent'
import useTimePeriod from 'hooks/useTimePeriod'
import { CONVO_DETAIL_REPORT_PATH } from 'layouts/ConversationsDetailReport/ConversationsDetailReport.constants'

import {
  formatHeatMapDrillDownQuery,
  getDayAsString,
} from './ConversationHeatMapChart.helpers'
import { HeatMap } from './HeatMap'
import useConversationHeatMapData from './useConversationHeatMapData.hook'

/**
 * Component that displays a heat map of conversations by time of day for the given time period.
 */
export const ConversationHeatMapChart = () => {
  const { chartData, isLoading, isEmpty } = useConversationHeatMapData()

  const timePeriod = useTimePeriod()
  const { pageFilters } = useCubeReportPageFiltersContext()
  const { accessFilters } = useCubeReportAccessFiltersContext()

  const { trackViewEvent } = useTrackDrillDownClickEvent(
    'ConversationHeatMapChart'
  )

  const handlePointClick = ({ point }) => {
    const { x: dayOfWeek, y: hourOfDay, value: resultCount } = point
    const dayOfWeekAsString: string = getDayAsString(dayOfWeek)

    const drillDownQuery = formatHeatMapDrillDownQuery(
      hourOfDay,
      dayOfWeekAsString,
      timePeriod.startDate,
      timePeriod.endDate,
      [...pageFilters, ...accessFilters]
    )

    // Track drill down click
    trackViewEvent({ totalRecords: resultCount })

    const drillDownQueryString =
      CubeQueryStringAdapter.toQueryString(drillDownQuery)
    const drillDownUrl = `${CONVO_DETAIL_REPORT_PATH}?${drillDownQueryString}`
    window.open(drillDownUrl, '_blank')
  }

  return (
    <Card
      rootProps={{
        id: 'chats-report--conversations-heatmap-card',
      }}
    >
      <Card.Header>
        <Header variant={'h3'}>Chats by time of day</Header>
        <Text variant={'metadata'}>
          How many chats happen during specific days and hours?
        </Text>
      </Card.Header>
      <Card.Content>
        <HeatMap
          series={chartData}
          onPointClick={handlePointClick}
          isLoading={isLoading}
          isEmpty={isEmpty}
        />
      </Card.Content>
    </Card>
  )
}
